import { transformSeries } from './utils';

export default function reviewCountTransformer({ primaryChart }) {
  const series = transformSeries(primaryChart);
  const options = {
    chart: {
      type: 'column',
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    colors: ['#D84315', '#FFA726', '#FFEE58', '#AED581', '#558B2F', '#91e8e1'],
  };
  return { series, options };
}
